module.exports = __webpack_public_path__ + "static/media/work4.27521fee.jpg";